export default __webpack_public_path__ + "static/media/travellers.ae5ceea2.jpg";